import { render } from "./GoalKRTypeActivity.vue?vue&type=template&id=b14d1480"
import script from "./GoalKRTypeActivity.vue?vue&type=script&lang=js"
export * from "./GoalKRTypeActivity.vue?vue&type=script&lang=js"
script.render = render

export default script